import { Injectable } from '@angular/core';
import { XHttpService } from '@app/core/services/x-http.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { StateService } from './state.service';

@Injectable({
    providedIn: 'root'
})
export class FavoritesService {
    ids: Array<string | number> = [];
    isChange: Subject<boolean> = new Subject();
    counterFav$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    tournament_ids$: BehaviorSubject<number[]> = new BehaviorSubject<number[]>([]);
    isLiveFav$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor(
        private http: XHttpService,
        private ss: StateService

    ) {

        this.setIds()
    }
    setIds() {
        this.http.get('/v3.2/favorite/index', this.http.httpParams(this.ss.botState.queryParams)).subscribe(res => {
            this.setResponse(res)
        })
    }

    isMatchExist(id: number | string) {
       if(!Array.isArray(this.ids)){return false}
        if (this.ids.find((el: string | number) => { return el == id })) {
            return true
        }
        return false
    }
    isTournamentExist(id: number) {
        if (this.tournament_ids$.value?.find((el: string | number) => { return el == id })) {
            return true
        }
        return false
    }
    addMatch(id: any) {
        if (this.ids) {
            this.ids.push(id);
        } else {
            this.ids = [id];
        }
        this.isChange.next(true);
        this.http.post(`/v3.2/favorite/save?id=${id}`, {}, {params: this.http.httpParams(this.ss.botState.queryParams)}).subscribe((res) => {
            this.setResponse(res)
        },
            err => {
                console.log(err);
                let ind = this.ids.indexOf(id);
                this.ids.splice(ind, 1);
                this.isChange.next(true)
            }
        );
    }
    addTournament(t_id:number,isApi:boolean=true){

        if (this.tournament_ids$.value&&this.tournament_ids$.value.length){
             this.tournament_ids$.next([...this.tournament_ids$.value,t_id])
        }else{
            this.tournament_ids$.next([t_id])
        }
        this.isChange.next(true);
        if(isApi){
        this.http.post(`/v3.2/favorite/save?tournament_id=${t_id}`, {}, {params: this.http.httpParams(this.ss.botState.queryParams)}).subscribe((res) => {
            this.setResponse(res);
        },
        err=>{
            console.log(err);
            this.delTournament(t_id,false)
         }
        )
        }

    }

    delTournament(t_id:number,isApi:boolean=true){
        let ind =  this.tournament_ids$.value.indexOf(t_id);
        let arr = [...this.tournament_ids$.value]
        if(ind !== -1){
            arr.splice(ind, 1);
            this.tournament_ids$.next(arr)
        }
        this.isChange.next(true);
        if(isApi){
            let p:any = {...this.ss.botState.queryParams}
        p['tournament_id']=t_id;
        this.http.delete("/v3.2/favorite/save", this.http.httpParams(p)).subscribe((res) => {
            this.setResponse(res)
         },
         err=>{
            console.log(err);
            this.addTournament(t_id,false)
         }
         );
        }

     }
    delMatch(id: number) {
        let ind = this.ids.indexOf(id);
        this.ids.splice(ind, 1);
        this.isChange.next(true)
        let p: any = { ...this.ss.botState.queryParams }
        p['id'] = id
        this.http.delete("/v3.2/favorite/save", this.http.httpParams(p)).subscribe((res) => {
           this.setResponse(res)
        },
            err => {
                this.ids.push(id);
                this.isChange.next(true)
            });
    }
    setResponse(res:{'ids':number[],'live':number,'tournament_ids':number[],'count':number}){
        res['ids']? this.ids = res['ids']:null;
        res['live'] > 0 ? this.isLiveFav$.next(true):this.isLiveFav$.next(false);
        res['tournament_ids'] ? this.tournament_ids$.next(res['tournament_ids']):null;
        this.counterFav$.next(res.count);
        this.isChange.next(true);
    }
}
